import script from "./responsibility.vue?vue&type=script&setup=true&lang=js"
export * from "./responsibility.vue?vue&type=script&setup=true&lang=js"

import "./responsibility.vue?vue&type=style&index=0&id=2a8f71b4&lang=scss&scoped=true"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a8f71b4"]])

export default __exports__